import React, { useState, useRef } from 'react';
import { Camera, Loader2, X, Images } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const absUrl = (u) => (u && u.startsWith('/') ? `${BACKEND}${u}` : u);

const StaffJobPhotos = ({ job, token }) => {
  const [photos, setPhotos] = useState(job?.staff_photos || []);
  const [uploading, setUploading] = useState(null);
  const [preview, setPreview] = useState(null);
  const refs = { before: useRef(null), after: useRef(null) };
  const headers = { Authorization: `Bearer ${token}` };

  const save = async (body) => {
    const { data } = await axios.put(`${API}/staff/jobs/${job.id}/photos`, body, { headers });
    setPhotos(data.staff_photos);
  };
  const upload = async (e, phase) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(phase);
    try {
      const urls = await Promise.all(files.map(async f => {
        const fd = new FormData(); fd.append('file', f);
        const r = await axios.post(`${API}/upload`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        return r.data.url;
      }));
      await save({ add: urls, phase });
    } catch (_) { alert('Erro ao enviar foto / Photo upload failed'); }
    finally { setUploading(null); if (refs[phase].current) refs[phase].current.value = ''; }
  };
  const remove = (u) => save({ remove: [u] });

  const Section = ({ phase, label }) => {
    const list = photos.filter(p => p.phase === phase);
    return (
      <div data-testid={`job-photos-${phase}`}>
        <div className="flex items-center justify-between mb-2">
          <p className="text-sm font-medium text-gray-700">{label} <span className="text-xs text-gray-400">({list.length})</span></p>
          <input ref={refs[phase]} type="file" accept="image/*" capture="environment" multiple className="hidden" onChange={(e) => upload(e, phase)} />
          <button type="button" onClick={() => refs[phase].current?.click()} disabled={uploading === phase} data-testid={`job-photos-add-${phase}`}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs rounded-lg bg-[#1a5c3a] text-white hover:bg-[#164d31] disabled:opacity-60">
            {uploading === phase ? <Loader2 className="animate-spin" size={14} /> : <Camera size={14} />} Adicionar / Add
          </button>
        </div>
        {list.length === 0 ? <p className="text-xs text-gray-400 border border-dashed rounded-lg p-3 text-center">Sem fotos / No photos</p> : (
          <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
            {list.map(p => (
              <div key={p.url} className="relative aspect-square rounded-lg overflow-hidden border group">
                <img src={absUrl(p.url)} alt="" className="w-full h-full object-cover cursor-pointer" onClick={() => setPreview(absUrl(p.url))} />
                <button type="button" onClick={() => remove(p.url)} data-testid="job-photo-remove" className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-0.5"><X size={12} /></button>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6" data-testid="job-photos-card">
      <h2 className="text-lg font-semibold text-gray-900 mb-1 flex items-center gap-2"><Images className="text-[#1a5c3a]" size={20} /> Fotos do Serviço / Job Photos</h2>
      <p className="text-xs text-gray-500 mb-4">As fotos vão diretamente para a galeria do admin. / Photos go straight to the admin gallery.</p>
      <div className="space-y-5">
        <Section phase="before" label="Antes / Before" />
        <Section phase="after" label="Depois / After" />
      </div>
      {preview && (
        <div className="fixed inset-0 bg-black/90 z-[70] flex items-center justify-center p-4" onClick={() => setPreview(null)} data-testid="job-photo-preview">
          <img src={preview} alt="" className="max-w-full max-h-full rounded-lg" />
          <button className="absolute top-4 right-4 text-white bg-black/50 rounded-full p-2"><X size={20} /></button>
        </div>
      )}
    </div>
  );
};

export default StaffJobPhotos;
